import React from 'react';
import { PM_PROVIDERS } from 'common/constants/constants';
import { Flex, WhiteSection } from 'components/base/layout-components';
import PMConfiguration from '../../connected-components/PMConfiguration';
import { getSensorAuthorization } from '../../services/project-management.service';
import { isSensorFinishSetup } from './JiraOAuth1/jiraSteps.common';
import ConnectJiraWrapper from './ConnectJira';
import JiraOAuth1 from './JiraOAuth1/JiraSetup';
import useFF from 'common/hooks/settings/useFF';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import JiraOAuth2Form from './JiraOAuth2/JiraOAuth2Form';
import { isSensorOAuth2 } from 'common/services/sensors.service';

const JiraSettings = props => {
  const {
    selectedTeam,
    isOrgSettings,
    sensorAuthorizations = [],
    entityName = 'board',
    apiTokens,
    setApiTokens
  } = props;
  const selectedManagementTool = getSensorAuthorization({
    sensorAuthorizations,
    sensorId: PM_PROVIDERS.JIRA
  });
  const isJiraOAuth2Enabled = useFF(FEATURE_FLAGS_NAMES.isJiraOAuth2Enabled);
  const isConnectionFinished =
    selectedManagementTool &&
    (isSensorFinishSetup(selectedManagementTool) ||
      isSensorOAuth2(selectedManagementTool));

  return (
    <Flex direction='column' justify='space-between' width='100%%'>
      {isConnectionFinished ? (
        <WhiteSection>
          <PMConfiguration
            entityName={entityName}
            selectedTeam={selectedTeam}
            isOrgSettings={isOrgSettings}
            selectedManagementTool={selectedManagementTool}
            apiTokens={apiTokens}
            setApiTokens={setApiTokens}
          />
        </WhiteSection>
      ) : (
        <ConnectJiraWrapper>
          {isJiraOAuth2Enabled ? (
            <JiraOAuth2Form />
          ) : (
            <JiraOAuth1
              {...props}
              selectedManagementTool={selectedManagementTool}
            />
          )}
        </ConnectJiraWrapper>
      )}
    </Flex>
  );
};

export default JiraSettings;
